import { Component, OnInit } from '@angular/core';
import { Seguro } from 'src/app/models/seguro';
import { MASKS } from 'ng-brazil';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { SeguroService } from 'src/app/services/seguro.service';

@Component({
  selector: 'app-cadastrar-seguro',
  templateUrl: './cadastrar-seguro.component.html',
  styleUrls: ['./cadastrar-seguro.component.scss']
})
export class CadastrarSeguroComponent implements OnInit {
  idSeguro;
  seguro = new Seguro();
  public MASKS = MASKS;

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private router: Router,
    private carregandoService: CarregandoService,
    private seguroService: SeguroService) { }

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('id')) {
      this.idSeguro = this.route.snapshot.paramMap.get('id');
      this.buscarSeguro();
    } else {
      this.seguro = new Seguro();
    }
  }

  buscarSeguro() {
    this.carregandoService.mostra('buscarSeguro');

    this.seguroService.consultarPorId(this.idSeguro).subscribe(seg => {
      this.seguro = seg;

      this.carregandoService.esconde('buscarSeguro');
    }, (erro) => {
      this.carregandoService.esconde('buscarSeguro');
      this.notificacaoService.erro(erro);
    });
  }

  salvar() {
    this.carregandoService.mostra('salvaSeguro');

    this.seguro.percentual = Number(this.seguro.percentual);
    this.seguro.obgAte = Number(this.seguro.obgAte);
    this.seguro.manualAPartirDe = Number(this.seguro.manualAPartirDe);

    this.seguroService.salvar(this.seguro).subscribe(() => {
      this.notificacaoService.sucesso('Seguro salvo com sucesso!!!');
      this.router.navigate(['configuracoes/seguro']).then(() => {
        this.carregandoService.esconde('salvaSeguro');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaSeguro');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {

  }

}
